import { Link } from "react-router-dom";
import BoxCall from "./SubCallwithUs/BoxCall";

function CallwithUs() {
    return (
        <>
            <div id="callwithUs"></div>

            <div
                className="flex flex-col mt-16 px-4 items-center
                           lg:px-20 lg:items-end
                           xl:px-40
                           2xl:px-60">

                <p className="t-purpleDark font-bold mb-5 lg:mb-10 rtol">تماس با ما :</p>

                {/* GRID MAIN WRAPPER */}
                <div
                    className="grid gap-6 w-full rtol
                               grid-cols-1
                               sm:grid-cols-2
                               lg:grid-cols-3">

                    {/* ---- ستون اول ---- */}
                    <div className="flex flex-col gap-6">
                        <BoxCall
                            image="/image/icon/address.png"
                            title="آدرس"
                            text="تهران، میدان رسالت، خیابان فرجام، نبش حیدرخانی، ساختمان آرشا، پلاک ۷۰۶، طبقه ۳، واحد ۱۵"
                        />

                        <BoxCall
                            image="/image/icon/postalCode.png"
                            title="کد پستی"
                            text="۱۶۸۴۷۹۳۰۷۹"
                        />
                    </div>

                    {/* ---- ستون دوم ---- */}
                    <div className="flex flex-col gap-6">
                        <BoxCall
                            image="/image/icon/Call.png"
                            title="شماره تماس"
                            text="(۰۲۱) ۷۶۹۰۱۱۳۲"
                        />

                        <BoxCall
                            image="/image/icon/email.png"
                            title="ایمیل"
                            text="support@bustan-messenger.ir"
                        />
                    </div>

                    {/* ---- ستون سوم: قوانین ---- */}
                    <div className="flex flex-col gap-6 lg:items-start items-center">
                        <div className="w-full flex flex-col mr-4">
                            <p className="text-slate-400">قوانین و شرایط استفاده</p>
                            <Link
                                to="/agreement"
                                className="block text-slate-800 text-sm w-full text-right hover:underline"
                            >
                                مشاهده قوانین و شرایط استفاده
                            </Link>
                        </div>
                    </div>
                </div>
                <p className="w-full text-center rtol mt-20 border-t border-slate-300 pt-4 text-slate-400">© ۱۴۰۴ بوستان. کلیه حقوق این اپلیکیشن محفوظ است.</p>
            </div>
        </>
    );
}
export default CallwithUs;